import React from "react";
import { connect } from "react-redux";
import { DownloadFileAction } from "../../../../actions";
import { actions as toastrActions, toastr } from "react-redux-toastr";
import { Toast } from "./style";

const CustomToast = props => {
  return (
    <div
      style={{
        display: "flex"
      }}
    >
      <div>فایل {props.tag} آماده دانلود است</div>
      <div>
        <a
          href={props.path}
          target="_blank"
          style={{ color: "#8f9eff" }}
          rel="noopener noreferrer"
        >
          دریافت فایل
        </a>
      </div>
    </div>
  );
};
class Index extends React.Component {
  state = {
    intervalId: "",
    filesLength: 0
  };
  static getDerivedStateFromProps(props, state) {
    let result = {};
    if (
      state.filesLength !== props.data.files.length &&
      props.data.files.length
    ) {
      if (state.intervalId === "") {
        let intervalId = setInterval(() => {
          props.checkFiles();
        }, 5000);
        result.intervalId = intervalId;
      }
      result.filesLength = props.data.files.length;
    }
    props.data.completedFiles.forEach(file => {
      if (file.toast) {
        toastr.error(" ", "", {
          timeOut: 20000,
          component: <CustomToast tag={file.tag} path={file.path} />
        });
        props.toasted(file.id);
      }
    });
    return result;
  }
  componentDidUpdate() {
    if (this.props.data.files.length <= 0) {
      if (this.state.intervalId !== "") {
        clearInterval(this.state.intervalId);
        this.setState({
          intervalId: "",
          filesLength: 0
        });
      }
    }
  }

  toastView() {
    const { data } = this.props;
    if (data.files.length && data.countToast) {
      return (
        <Toast>
          <div>
            {data.files.length} فایل در حال آماده‌سازی برای دانلود می‌باشد
          </div>
          <div>
            <i
              className="icon mapsa-close"
              onClick={() => this.props.countToastToggle()}
            />
          </div>
        </Toast>
      );
    }
  }
  render() {
    return <React.Fragment>{this.toastView()}</React.Fragment>;
  }
}

const mapStateToProps = store => {
  return {
    data: store.DownloadFile
  };
};
const mapDispatchToProps = dispatch => {
  return {
    addToast: data => {
      dispatch(toastrActions.add(data));
    },
    removeToast: id => {
      dispatch(toastrActions.remove(id));
    },
    countToastToggle: () => {
      dispatch(DownloadFileAction.countToastToggle());
    },
    checkFiles: () => {
      dispatch(DownloadFileAction.checkFilesRequest());
    },
    toasted: id => {
      dispatch(DownloadFileAction.toasted(id));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
